module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-sieron-rise-above-your-body-kinesitherapie-brakel-thumbnail.5517d74f.png";